import React, { Component } from "react";

export default class AvisoPrestamo extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
  }


  render(props) {
    if(this.props.prestamos.length > 0){
      return (
        <div className="col-md-12">
            
            <div className="row">
                <div className="callout callout-success importante">
                  <div className="row">
                    <div className="col-md-12">
                      <i className="fas fa-exclamation-circle card-fa-icono-info" style={{marginRight: 5,fontSize:25}}/> 
                      <p style={{fontSize:20, fontFamily: "Montserrat-Semibold"}}>¡Importante!</p> 
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                    <p className="texto-importante"> *Si Usted tiene cuotas adelantadas, recuerde que debe abonar indefectiblemente una cuota por mes en la fecha habitual, caso contrario, recuperará intereses. </p>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      );

    }else{
      return null;
    }  
  }
}